import { availableLanguages } from '@/locales/i18n';

import {
  BuddingMethods,
  BuddingSensitivity,
  CameraType,
  CellSize,
  ChamberDepth,
  SquareSize,
  Stain,
  SugarUnit,
} from '../types';

export interface IDropdownOption {
  label: number | string;
  value: number | string;
}

export const getImagesPerAnalysisOptions = (
  start: number,
  end: number,
): IDropdownOption[] => {
  return [...Array(end).keys()].slice(start).map((value) => ({ label: value, value }));
};

export const getStainOptions = (): IDropdownOption[] => {
  return [
    { label: 'userSettings.methyleneBlue', value: Stain.MethyleneBlue },
    { label: 'userSettings.methyleneViolet', value: Stain.MethyleneViolet },
    { label: 'userSettings.methyleneVioletBeta', value: Stain.MethyleneVioletBeta },
  ];
};

export const getCellSizeOptions = (): IDropdownOption[] => {
  return [
    { label: 'userSettings.cellSizes.small', value: CellSize.Small },
    { label: 'userSettings.cellSizes.medium', value: CellSize.Medium },
    { label: 'userSettings.cellSizes.large', value: CellSize.Large },
    { label: 'userSettings.cellSizes.all', value: CellSize.All },
  ];
};

export const getCameraOptions = (): IDropdownOption[] => {
  return [
    { label: 'userSettings.oculyzeCamera', value: CameraType.Oculyze },
    { label: 'userSettings.labCamera', value: CameraType.Lab },
  ];
};

export const getLangugeOptions = () => {
  return [...availableLanguages.map((value) => ({ label: value, value }))];
};

export const getSugarUnitOptions = (): IDropdownOption[] => {
  return [
    { label: 'userSettings.sugarUnits.oechsle', value: SugarUnit.Oechsle },
    { label: 'userSettings.sugarUnits.brix', value: SugarUnit.Brix },
    { label: 'userSettings.sugarUnits.kmw', value: SugarUnit.Kmw },
    { label: 'userSettings.sugarUnits.baume', value: SugarUnit.Baume },
    { label: 'userSettings.sugarUnits.densityGpl', value: SugarUnit.DensityGpl },
  ];
};

export const getChamberDepthOptions = (): IDropdownOption[] => {
  return [
    { label: 'userSettings.chamberDepthUnits.0_1', value: ChamberDepth.O_1 },
    { label: 'userSettings.chamberDepthUnits.0_2', value: ChamberDepth.O_2 },
    { label: 'userSettings.chamberDepthUnits.0_25', value: ChamberDepth.O_25 },
    { label: 'userSettings.chamberDepthUnits.0_5', value: ChamberDepth.O_5 },
  ];
};

export const getSquareSizeOptions = (): IDropdownOption[] => {
  return [
    { label: 'userSettings.squareSizeUnits.O_0025', value: SquareSize.O_0025 },
    { label: 'userSettings.squareSizeUnits.O_0625', value: SquareSize.O_0625 },
    { label: 'userSettings.squareSizeUnits.O_04', value: SquareSize.O_04 },
  ];
};

export const getBuddingMethods = (): IDropdownOption[] => {
  return [
    {
      label: 'userSettings.ethanolBuddingMethods.allCells',
      value: BuddingMethods.ALL_CELLS,
    },
    {
      label: 'userSettings.ethanolBuddingMethods.onlyBudding',
      value: BuddingMethods.BUDDING_ONLY,
    },
  ];
};

export const getBuddingSensitivity = (): IDropdownOption[] => {
  return [
    {
      label: 'userSettings.ethanolBuddingSensitivities.low',
      value: BuddingSensitivity.LOW,
    },
    {
      label: 'userSettings.ethanolBuddingSensitivities.high',
      value: BuddingSensitivity.HIGH,
    },
    {
      label: 'userSettings.ethanolBuddingSensitivities.veryHigh',
      value: BuddingSensitivity.VERY_HIGH,
    },
  ];
};
